<template>
  <div
    id="point-setting"
    class="p-10 w-100 h-100 position-absolute"
    :style="{ height: height, top: top }"
  >
    <div class="w-100 h-100">
      <el-card
        class="w-100 point-list business_dialog_title"
        :style="{ height: showPointSetting ? 'calc(50% - 10px)' : '100%' }"
        :body-style="{ height: 'calc(100% - 20px)', padding: '0px' }"
      >
        <span slot="header" class="flex-row-between fz-14 m-b-5">
          点位列表
          <span class="iconfont icon-close r cur_pointer" @click="closeComponent"></span>
        </span>

        <el-tree
          class="h-100 dialog-body p-t-5"
          highlight-current
          lazy
          :load="loadNode"
          ref="pointTree"
          :data="pointTypeTreeList"
          @node-click="handleClick"
          :props="defaultTreeProps"
          node-key="id"
        >
          <span
            slot-scope="{ node, data }"
            class="el-tree-node__label w-100 text-overflow flex-align-center flex-row-between"
          >
            <span class="ell tl tree-label">{{ node.label }}</span>
            <p class="m-r-10 m-l-10 tr tree-btn">
              <el-tooltip
                content="新增"
                v-if="((moduleAuth && moduleAuth.create) || currentEnv.DEBUG) && node.level === 1"
                :open-delay="1000"
                placement="top"
              >
                <el-button
                  type="primary"
                  size="mini"
                  class="m-l-0 m-r-5"
                  icon="iconfont icon-add"
                  @click.stop="() => openPointDialog(data, node, 'add')"
                  v-buttonMonitor="{ name: '新增', operate: 'create' }"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                content="编辑"
                :open-delay="1000"
                placement="top"
                v-if="(moduleAuth && moduleAuth.update) || currentEnv.DEBUG"
              >
                <el-button
                  type="warning"
                  size="mini"
                  class="m-l-0 m-r-5"
                  icon="iconfont icon-edit"
                  @click.stop="() => openPointDialog(data, node, 'edit')"
                  v-buttonMonitor="{ name: '编辑', operate: 'update' }"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                content="删除"
                :open-delay="1000"
                placement="top"
                v-if="(moduleAuth && moduleAuth.delete) || currentEnv.DEBUG"
              >
                <el-button
                  type="danger"
                  size="mini"
                  class="m-l-0"
                  icon="iconfont icon-delete"
                  @click.stop="deleteNode(data, node)"
                  v-buttonMonitor="{ name: '删除', operate: 'update' }"
                ></el-button>
              </el-tooltip>
            </p>
          </span>
        </el-tree>
      </el-card>
      <el-card
        class="w-100 m-t-10 position-relative setting-card"
        v-if="showPointSetting"
        :body-style="{ width: '100%', height: '100%', padding: '0px' }"
      >
        <el-row class="flex-align-center d-flex">
          <el-col :span="12">
            <span class="fz-14">点位设置</span>
          </el-col>
          <el-col :span="12">
            <el-tooltip content="关闭" placement="top" effect="dark" :open-delay="1000">
              <!-- content to trigger tooltip here -->
              <i
                @click="closePointSetting"
                class="cur_pointer iconfont icon-close r position-absolute close-btn"
              ></i>
            </el-tooltip>
          </el-col>
        </el-row>
        <div class="m-t-5 p-10 point-table">
          <el-form
            :model="pointForm"
            :rules="pointRules"
            ref="pointForm"
            label-width="85px"
            size="small"
          >
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="点位名称" prop="name">
                  <el-input
                    placeholder="请填写点位名称"
                    v-model="pointForm.name"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="点位编码" prop="code">
                  <el-input
                    placeholder="请填写点位编码"
                    v-model="pointForm.code"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="点位样式" prop="style">
                  <el-row class="flex-align-center d-flex">
                    <el-col :span="20">
                      <el-popover
                        ref="pointStylePopover"
                        popper-class="document_select-popper"
                        placement="bottom-start"
                        width="300"
                        trigger="click"
                      >
                        <div class="style-menus">
                          <el-row
                            :gutter="10"
                            class="w-100"
                            v-for="(item, index) in iconUrlList"
                            :key="index"
                          >
                            <el-col :span="7" class="m-t-5">
                              <span class="icon-title">{{ item.title }}</span>
                            </el-col>
                            <el-col :span="17">
                              <el-row :gutter="10">
                                <el-col
                                  :span="4"
                                  v-for="(v, i) in item.iconList"
                                  :key="i"
                                  class="icon-item flex-align-center flex-row-center m-b-10"
                                  :class="{ 'active-style-name': pointForm.style === v }"
                                >
                                  <i
                                    @click="chooseStyle(v)"
                                    class="cur-pointer style-item"
                                    :style="`background:url('${iconUrl}${v}') no-repeat`"
                                  ></i>
                                </el-col>
                              </el-row>
                            </el-col>
                          </el-row>
                        </div>
                        <el-input
                          slot="reference"
                          placeholder="请填写点位样式"
                          v-model="pointForm.style"
                          clearable
                        ></el-input>
                      </el-popover>
                    </el-col>
                    <el-col :span="4" class="flex-row-end flex-align-center">
                      <div class="icon-choosed flex-align-center d-flex">
                        <span
                          class="icon-span"
                          :style="
                            `background:url('${iconUrl}${pointForm.style}') no-repeat center center`
                          "
                        ></span>
                      </div>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="目录节点" prop="type">
                  <el-select
                    popper-class="document_select-popper"
                    class="w-100"
                    filterable
                    v-model="pointForm.type"
                    clearable
                  >
                    <el-option
                      v-for="item in pointTypeTreeList"
                      :label="item.name"
                      :value="item.id"
                      :key="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="关联模型">
                  <el-input
                    placeholder="自动获取"
                    v-model="pointForm.relationModel"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item label="点位位置" prop="location">
                  <div class="d-flex flex-row-between">
                    <el-tooltip
                      class="m-l-5"
                      :content="pointForm.location[0]"
                      placement="top"
                      effect="dark"
                      :open-delay="1000"
                    >
                      <div>
                        X: <el-input class="input-width" v-model="pointForm.location[0]"></el-input>
                      </div>
                    </el-tooltip>
                    <el-tooltip
                      class="m-l-5"
                      :content="pointForm.location[1]"
                      placement="top"
                      effect="dark"
                      :open-delay="1000"
                    >
                      <div>
                        Y:
                        <el-input class="input-width" v-model="pointForm.location[1]"></el-input>
                      </div>
                    </el-tooltip>
                    <el-tooltip
                      class="m-l-5"
                      :content="pointForm.location[2]"
                      placement="top"
                      effect="dark"
                      :open-delay="1000"
                    >
                      <div>
                        Z:
                        <el-input class="input-width" v-model="pointForm.location[2]"></el-input>
                      </div>
                    </el-tooltip>
                    <span class="m-l-5">
                      <el-button type="warning" size="mini" @click="chooseLocation">选点</el-button>
                    </span>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer tr">
            <el-button type="primary" size="mini" :loading="savePointLoading" @click="submitPoint"
              >保 存</el-button
            >
          </div>
        </div>
      </el-card>
    </div>
    <el-dialog
      title="编辑点位类别"
      :visible.sync="pointTypeDialog"
      width="30%"
      @close="cancleEditPointType"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
    >
      <el-form
        :model="pointTypeForm"
        ref="pointTypeForm"
        label-width="120px"
        :rules="pointTypeRules"
      >
        <el-form-item label="点位类别名称" prop="name">
          <el-input v-model="pointTypeForm.name" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancleEditPointType">取 消</el-button>
        <el-button :loading="savePointTypeLoading" type="primary" @click="submitPointType"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ApiMixinDocument from '@/assets/js/api/documents'
import ConfirmAuth from '@/assets/js/confirmAuth'
import PointManage from '@/services/pointManage'

export default {
  name: 'PointSetting',
  mixins: [ApiMixinDocument],
  components: {},
  props: {
    player: {
      type: Object,
      default: () => {
        return {}
      },
    },
    documentId: {
      type: String,
      default: '',
    },
    tagCode: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: '',
    },
    top: {
      type: String,
      default: '',
    },
  },
  data() {
    const checkNumber = (rule, value, calback) => {
      const numberReg = /^(-)?(\d+)(\.\d+)?$/
      const checkValue = _.every(value, (item) => {
        return numberReg.test(item)
      })
      if (!checkValue) {
        calback(new Error('请输入合理的点位位置'))
      } else {
        calback()
      }
    }
    return {
      markerList: [], // 存储当前页面所有标记
      moduleAuth: {},
      pointTypeTreeList: [],
      // 目录树的配置项
      defaultTreeProps: {
        children: 'children',
        label: 'name',
        isLeaf: (data, node) => {
          if (data.pointTypeId) {
            return true
          }
        },
      },
      pointTypeDialog: false, // 编辑点位类别名称
      pointForm: {
        name: '',
        code: '',
        style: '',
        type: '',
        relationModel: '',
        location: ['0', '0', '0'],
      },
      showPointSetting: false,
      pointRules: {
        code: [{ required: true, message: '请填写点位编码', trigger: 'blur' }],
        name: [{ required: true, message: '请填写点位名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择测点类型', trigger: 'change' }],
        style: [{ required: true, message: '请选择点位样式', trigger: 'change' }],
        location: [{ validator: checkNumber, trigger: 'blur' }],
      },
      pointLocation: [], // 点位位置
      pointStyleList: [{ value: '111', label: '样式1' }], // 点位样式列表
      treeNodeList: [], // 点位目录节点列表
      savePointLoading: false, // 保存按钮loading
      activeName: '',
      selectModel: '',
      modelList: [],
      nodeData: {},
      resolveData: {},
      pointId: null,
      // 点位类型编辑form数据
      pointTypeForm: {
        name: '',
      },
      pointTypeRules: {
        name: [{ required: true, message: '请填写名称', trigger: 'blur' }],
      }, // 表单验证
      pointTypeId: null,
      savePointTypeLoading: false,
      pointList: [], // 点位列表
      iconUrlList: [
        {
          title: '默认',
          iconList: [
            'icon-default-green.png',
            'icon-default-blue.png',
            'icon-default-red.png',
            'icon-default-yellow.png',
            'icon-default-purple.png',
          ],
        },
        {
          title: '应急物资',
          iconList: [
            'icon-fireextinguisher-green.png',
            'icon-fireextinguisher-blue.png',
            'icon-fireextinguisher-red.png',
            'icon-fireextinguisher-yellow.png',
            'icon-fireextinguisher-purple.png',
          ],
        },
        {
          title: '作业',
          iconList: [
            'icon-pushpin-green.png',
            'icon-pushpin-blue.png',
            'icon-pushpin-red.png',
            'icon-pushpin-yellow.png',
            'icon-pushpin-purple.png',
          ],
        },
        {
          title: '工业视频',
          iconList: [
            'icon-camara-green.png',
            'icon-camara-blue.png',
            'icon-camara-red.png',
            'icon-camara-yellow.png',
            'icon-camara-purple.png',
          ],
        },
      ],
      iconUrl: '/static/img/bc/pointStyle/',
      relationModelDocumentId: '',
      relationModelDocumentName: '',
      currentPlayer: null,
      handleClickTimerOut: null,
    }
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
  },
  watch: {
    player: {
      handler(val) {
        if (val && val.Native) {
          this.currentPlayer = val
          this.$nextTick(async () => {
            this.loadPoint(null)
          })
        }
      },
      deep: true,
    },
    tagCode(val) {
      if (val) {
        this.$nextTick(() => {
          this.pointForm.relationModel = val
        })
      }
    },
    documentId(val) {
      this.relationModelDocumentId = val
    },
  },
  async created() {
    this.relationModelDocumentId = this.documentId
    if (this.player && this.player.Native) {
      this.currentPlayer = this.player
      this.loadPoint(null)
    }
    this.moduleAuth = await ConfirmAuth('点位设置')
    this.getPointTypeList()
  },
  methods: {
    closeComponent() {
      this.$emit('closeComponent', 'PointSetting')
    },
    // 加载点位到模型
    async loadPoint(typeId) {
      if (this.currentPlayer && this.currentPlayer.Native) {
        await this.getPointList(typeId)
        // 检查是否有已知的标记
        const markerList = await PlayerUtils.call(this.currentPlayer.Native.GisMarker.getMarkerList)
        _.forEach(markerList, (el) => {
          if (this.markerList.includes(el.id)) {
            this.currentPlayer.Native.GisMarker.destroy(el.id)
          }
        })
        this.markerList = []
        _.forEach(this.pointList, async (item) => {
          const pos = item.location.split(',')
          // 加载锚点
          const imgId = await PlayerUtils.call(
            this.currentPlayer.Native.GisMarker.loadImage,
            `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/${item.style}`
          )
          this.drawPoint(pos, imgId)
        })
      }
    },
    // 绘制点位
    async drawPoint(pos, imgId) {
      const option = {
        pos, // 定位点，世界坐标，三维向量
        visible: true, // 显示隐藏状态
        size: [20, 20], // 整体尺寸，二维向量，-1表示不限制，自动大小
        nodeOffset: [-10, -10], // 相对定位点的偏移量，二维向量
        imgId, // 图片
        imgSize: [20, 20], // 图片尺寸，-1为应用图片大小，如[32, -1]为宽度拉伸或压缩到32，高度为图片高度
        imgOffset: [0, 0], // 图片相对标记的偏移量
        text: '', // 文本
        fontSize: 14.0, // 字体大小
        breakWidth: 250, // 最大行宽，超过宽度会换行，-1表示限制，换行符（'\n'）会强制换行不受控制
        textOffset: [0, 0], // 文字相对标记的偏移量
        textColor: 0xffffffff, // 文本颜色
        title: '', // 标题
        titleFontSize: 18.0, // 标题文字大小
        titleColor: 0xffffffff, // 标题颜色
        userData: null, // 用户数据，仅帮外部系统保存数据
      }
      const markerId = await this.currentPlayer.Native.GisMarker.create(option)
      this.markerList.push(markerId)
    },
    // 保存点位类型
    submitPointType() {
      this.$refs.pointTypeForm.validate(async (valid) => {
        if (valid) {
          const params = {
            model: this.pointTypeForm,
            noRepeatName: ['name'],
          }
          params.model.siteId = this.currentProject.id
          params.model.parentId = ''
          // 接收返回结果
          params.model.id = this.pointTypeId
          const res = await PointManage.editPointType(params)
          if (res && res.code === 0) {
            this.$message.success(res.msg)
            this.cancleEditPointType()
            this.getPointTypeList()
          } else {
            this.$message.warning(res.message)
          }
          console.log(res)
        } else {
          return false
        }
      })
    },
    // 取消编辑点位类型
    cancleEditPointType() {
      this.pointTypeDialog = false
      this.pointTypeForm = this.$options.data().pointTypeForm
      this.pointTypeId = null
      this.$refs.pointTypeForm.resetFields()
    },
    // 选择样式
    chooseStyle(val) {
      this.$refs.pointStylePopover.showPopper = false
      this.pointForm.style = val
    },
    // 获取点位列表
    async getPointList(typeId) {
      const params = {
        pageno: 1,
        pagesize: 99999,
        pointtypeid: typeId || '',
        relation_model_document_id: this.relationModelDocumentId,
      }
      const res = await PointManage.getPointList(params)
      if (res && res.data && res.code === 0) {
        this.pointList = res.data
      }
    },
    // 加载目录树
    async getPointTypeList() {
      const parmas = {
        pageNo: 1,
        pageSize: 999,
      }
      const res = await PointManage.getPointTypeList(parmas)
      console.log(res)
      if (res && res.code === 0 && res.data) {
        this.pointTypeTreeList = res.data
      }
    },
    handleClick(data) {
      if (this.handleClickTimerOut) {
        clearTimeout(this.handleClickTimerOut)
      }
      this.handleClickTimerOut = setTimeout(async () => {
        if (this.currentPlayer && this.currentPlayer.Native) {
          if (data.pointTypeId) {
            const pos = data.location.split(',')
            const modelInfo = await this.currentPlayer.Native.Model.getInfo(this.documentId)
            /**
             * arr: 坐标点
             * modelInfo.nodePtr： 模型所在的坐标点
             */
            this.currentPlayer.Native.Camera.moveToPos(pos, modelInfo.nodePtr, 3, 0)
            console.log(pos)
          }
        }
      }, 500)
    },
    // 设备树懒加载
    async loadNode(node, resolve) {
      if (node.level === 1) {
        const params = {
          pageno: 1,
          pagesize: 999,
          pointtypeid: node.data.id,
          relation_model_document_id: this.relationModelDocumentId,
        }
        const res = await PointManage.getPointList(params)
        if (res && res.data && res.code === 0) {
          this.nodeData = node
          this.resolveData = resolve
          return resolve(res.data)
        }
      } else if (node.level > 1) {
        return resolve([])
      }
      return resolve([])
    },
    // 打开点位新增
    openPointDialog(data, node, type) {
      this.pointId = null
      this.nodeData = node
      if (type === 'edit') {
        if (data.pointTypeId) {
          this.nodeData = node.parent
          this.showPointSetting = true
          this.pointForm = this.$options.data().pointForm
          this.pointForm.type = data.pointTypeId
          this.pointForm.relationModel = data.relationModel
          this.pointForm.style = data.style
          this.pointForm.code = data.code
          this.pointForm.name = data.name
          this.pointForm.location = data.location.split(',')
          this.pointId = data.id
          console.log(this.pointId)
        } else {
          this.pointTypeId = data.id
          this.pointTypeForm.name = data.name
          this.pointTypeDialog = true
        }
      } else {
        this.showPointSetting = true
        this.pointForm = this.$options.data().pointForm
        this.pointForm.type = data.id
      }
    },
    deleteNode(data, node) {
      if (data.pointTypeId) {
        this.deletePoint(data.id, node)
      } else {
        this.deletePointType(data.id)
      }
    },
    // 删除点位类别
    deletePointType(id) {
      this.$confirm('确认要删除点位类别及其所有点位吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await PointManage.deletePointType([id])
          if (res && res.code === 0) {
            this.$message.success('删除成功！')
            this.getPointTypeList()
            this.loadPoint(null)
          } else {
            this.$message.warning(res.message)
          }
        })
        .catch(() => {})
    },
    // 删除点位
    deletePoint(id, node) {
      this.nodeData = node.parent
      this.$confirm('确认要删除点位吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await PointManage.deletePoint([id])
          if (res && res.code === 0) {
            this.$message.success('删除成功！')
            this.nodeData.loaded = false
            this.nodeData.expand()
            this.loadPoint(null)
          } else {
            this.$message.warning(res.message)
          }
        })
        .catch(() => {})
    },
    // 保存点位
    submitPoint() {
      this.$refs.pointForm.validate(async (val) => {
        if (val) {
          this.savePointLoading = true
          const params = {
            code: this.pointForm.code,
            name: this.pointForm.name,
            pointTypeId: this.pointForm.type,
            siteId: this.currentProject.id,
            relationModel: this.pointForm.relationModel,
            style: this.pointForm.style,
            location: this.pointForm.location.join(','),
            relationModelDocumentId: this.relationModelDocumentId,
            relationModelDocumentName: this.relationModelDocumentName,
          }
          // 接收接口返回值
          let res = null
          if (this.pointId) {
            params.id = this.pointId
            res = await PointManage.editPoint(params)
          } else {
            res = await PointManage.insertPoint(params)
          }
          this.savePointLoading = false
          if (res && res.code === 0) {
            this.nodeData.loaded = false
            this.nodeData.expand()
            this.closePointSetting()
            this.loadPoint(null)
          } else {
            this.$message.warning(res.message)
          }
        } else {
          return false
        }
      })
    },
    // 关闭点位设置
    closePointSetting() {
      this.showPointSetting = false
      this.$refs.pointForm.resetFields()
      this.pointForm = this.$options.data().pointForm
      this.pointId = null
    },
    // 模型上选点
    async chooseLocation() {
      if (this.currentPlayer && this.currentPlayer.Native) {
        const location = await PlayerUtils.call(this.currentPlayer.Native.Camera.getAnchorPos)
        this.pointForm.location = _.map(location, (val) => {
          return String(val)
        })
      }
    },
  },
  async destroyed() {
    // 检查是否有已知的标记
    const markerList = await PlayerUtils.call(this.currentPlayer.Native.GisMarker.getMarkerList)
    _.forEach(markerList, (el) => {
      if (this.markerList.includes(el.id)) {
        this.currentPlayer.Native.GisMarker.destroy(el.id)
      }
    })
  },
}
</script>
<style lang="scss">

@import '../../css/select.scss';

</style>
<style lang="scss" scoped>

@import '../../css/index.scss';
#point-setting {
  z-index: 99;
  width: 368px;
  right: 35px;
  border-radius: 2px;
  transition: left 0.3s;
  background-color: rgba(46, 107, 176, 0.5) !important;
}
/deep/ .el-card__header,
/deep/ .el-card {
  border: none;
}
.configure-table {
  height: 90%;
}
.table-footer {
  bottom: 0;
  right: 0;
}
.card-top {
  height: calc(50% - 10px);
}
.card-footer {
  height: 50%;
}
.close-btn {
  top: 5px;
  right: 5px;
}
.input-width {
  width: 39px;
  text-overflow: ellipsis;
}
.style-menus {
  max-height: 200px;
  overflow-y: auto;
}
.style-item {
  display: inline-block;
  background-size: 100% 100% !important;
  width: 20px;
  height: 20px;
}
.icon-item {
  height: 30px;
}
.active-style-name {
  border-radius: 4px;
  background-color: #dcdfe6;
  border: 0.25px solid #dcdfe6;
}
.icon-choosed {
  background-color: #dcdfe6;
  height: 30px;
  padding: 0 5px;
  color: #409eff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}
.icon-span {
  display: inline-block;
  width: 20px;
  height: 20px;
  background-size: 100% 100% !important;
}
.setting-card {
  height: 50%;
}
.point-list,
.setting-card {
  color: #fff;
}
.dialog-body,
.point-table {
  background-color: rgba(24, 41, 72, 0.5) !important;
}
.point-table {
  height: calc(100% - 30px);
  overflow-y: scroll;
}

</style>
